import { minutesToMs, partnerApi } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

export const usePartnerConsentUserConsentQuery = () => {
	return useQuery({
		queryFn: async () =>
			(await partnerApi).fetchAclPartnerConsentUserConsent({
				'details[]': ['consentTypeTranslations']
			}),
		queryKey: ['partnerConsentUserConsent'],
		select: res => res.data || [],
		staleTime: minutesToMs(1)
	});
};
